import { render } from "./VuexDateRangeSearchItem.vue?vue&type=template&id=0c05587c"
import script from "./VuexDateRangeSearchItem.vue?vue&type=script&lang=js"
export * from "./VuexDateRangeSearchItem.vue?vue&type=script&lang=js"
script.render = render

export default script